export var VERSION = '2.17.11';
//# sourceMappingURL=version.js.map